<template>
  <div>
    <div class="fields" style="display: flex">
      <el-form
        :model="form"
        ref="form"
        label-width="120px"
        style="display: flex"
      >
        <!-- <el-form-item label="变量">
          <el-select v-model="form.selectVal" multiple placeholder="请选择变量">
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="时间">
          <el-date-picker
            v-model="form.variableDate"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="history-btns" style="margin-left: 100px">
        <el-row style="display: flex">
          <el-col>
            <el-button
              @click="backPage()"
              style="border: 1px solid #00cc00; color: #00cc00"
              >返回</el-button
            >
          </el-col>
          <!-- <el-col style="margin-left: 30px">
            <el-button
              @click="exportData()"
              :disabled="exporting"
              style="border: 1px solid #00cc00; color: #00cc00"
              >导出</el-button
            >
          </el-col> -->
          <!-- <el-col style="margin-left: 30px">
            <el-button
              @click="queryAllData"
              style="border: 1px solid #00cc00; color: #00cc00"
              >查询全部</el-button
            >
          </el-col> -->
          <el-col style="margin-left: 30px"
            ><el-button @click="resetForm()">重置</el-button></el-col
          >
        </el-row>
      </div>
    </div>
    <div class="history-charts">
      <!-- 使用v-for循环渲染图表行 -->
      <div
        v-for="(row, rowIndex) in chartRows"
        :key="rowIndex"
        style="display: flex; width: 95%; gap: 10px; margin-bottom: 20px;"
      >
        <!-- 每行渲染3个图表 -->
        <div
          v-for="chart in row"
          :key="chart.domId"
          class="chart-container"
          :style="{ flex: 1 }"
        >
          <div class="chart-header">
            <span class="chart-title">{{ chart.titleData }}</span>
            <el-button
              size="mini"
              @click.stop="queryChartData(chart)"
              style="border: 1px solid #00cc00; color: #00cc00; margin-left: 10px;"
            >
              查询
            </el-button>
          </div>
          <Echarts
            :chartsType="chart.chartsType"
            :width="chart.width"
            :height="chart.height"
            :seriesData="chart.seriesData"
            :xAxisData="chart.xAxisData"
            :domId="chart.domId"
            :legendData="chart.legendData"
            :ref="chart.domId"
          ></Echarts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echarts from "./deviceEcharts";
import { HOST } from "@/utils/host";

export default {
  name: "HistoryNormal",
  components: { Echarts },
  data() {
    return {
      url: "battery/tree/historyField",
      options: [],
      list: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      loading: false,
      exporting: false,
      form: { selectVal: [], variableDate: [] },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近5分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 300 * 1000);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近10分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 600 * 1000);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近半小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 1800 * 1000);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近1小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近6小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近12小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 12);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近两天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      extVolts: [],
      cells: [],
      temps: [],
      // 图表数据
      chartData: {
        currData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "总电流(A)",
          legendData: [],
          seriesData: [],
          domId: "curr_echarts",
          xAxisData: [],
          queryTypes: ["current"]
        },
        voltData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "总电压(V)",
          legendData: [],
          seriesData: [],
          domId: "volt_echarts",
          xAxisData: [],
          queryTypes: ["voltage"]
        },
        socData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "SOC(%)",
          legendData: [],
          seriesData: [],
          domId: "soc_echarts",
          xAxisData: [],
          queryTypes: ["soc"]
        },
        mCellData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "最高/最低/平均单体电压(mv)",
          legendData: [],
          seriesData: [],
          domId: "mCell_echarts",
          xAxisData: [],
          queryTypes: ["maxCellVolt", "minCellVolt", "avgCellVolt"]
        },
        mCellPosData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "最高/最低单体位置",
          legendData: [],
          seriesData: [],
          domId: "mCellPos_echarts",
          xAxisData: [],
          queryTypes: ["maxCellPos", "minCellPos"]
        },
        mCellDiffData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "单体压差(mv)",
          legendData: [],
          seriesData: [],
          domId: "mCellDiff_echarts",
          xAxisData: [],
          queryTypes: ["diffCellVolt"]
        },
        mTempData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "最高/最低/平均温度(°C)",
          legendData: [],
          seriesData: [],
          domId: "mTemp_echarts",
          xAxisData: [],
          queryTypes: ["maxTemp", "minTemp", "avgTemp"]
        },
        mTempPosData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "最高/最低温度位置",
          legendData: [],
          seriesData: [],
          domId: "mTempPos_echarts",
          xAxisData: [],
          queryTypes: ["maxTempPos", "minTempPos"]
        },
        mTempDiffData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "温差(°C)",
          legendData: [],
          seriesData: [],
          domId: "mTempDiff_echarts",
          xAxisData: [],
          queryTypes: ["diffTemp"]
        },
        highVoltData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "外总压(V)",
          legendData: [],
          seriesData: [],
          domId: "highVolt_echarts",
          xAxisData: [],
          queryTypes: []
        },
        cellsData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "单体电压(mv)",
          legendData: [],
          seriesData: [],
          domId: "cells_echarts",
          xAxisData: [],
          queryTypes: []
        },
        tempsData: {
          chartsType: "line",
          width: "100%",
          height: "300px",
          titleData: "温感(°C)",
          legendData: [],
          seriesData: [],
          domId: "temps_echarts",
          xAxisData: [],
          queryTypes: []
        }
      }
    };
  },
  computed: {
    // 将图表数据分组为每行3个
    chartRows() {
      const charts = Object.values(this.chartData);
      const rows = [];
      for (let i = 0; i < charts.length; i += 3) {
        rows.push(charts.slice(i, i + 3));
      }
      return rows;
    }
  },
  mounted() {},
  methods: {
    backPage() {
      this.$router.go(-1);
    },
    exportData() {
      this.exporting = true;
      const url = HOST + "/battery/dcDevice/history?isExport=true";
      let queryData = {};
      if (this.form.variableDate.length > 0) {
        const date1 = new Date(this.form.variableDate[0]);
        const date2 = new Date(this.form.variableDate[1]);
        const diffTime = Math.abs(date2 - date1);
        console.log;
        if (diffTime > 3600 * 1000 * 24 * 3) {
          this.$message({
            message: "查询时间请不要超过3天！",
            type: "warning"
          });
          return;
        }
        queryData = {
          id: this.$route.query.data,
          queryTime: this.form.variableDate.join(","),
          variableValues: this.form.selectVal.join(","),
          token: window.localStorage.getItem("token")
        };
      } else {
        queryData = {
          queryTime: "",
          id: this.$route.query.data,
          variableValues: this.form.selectVal.join(","),
          token: window.localStorage.getItem("token")
        };
      }
      $.fileDownload(url, {
        httpMethod: "get",
        data: queryData,
        failCallback: (html, url) => {
          this.$notify({
            title: "失败",
            message: "导出失败",
            type: "error"
          });
          this.exporting = false;
        },
        successCallback: () => {
          this.exporting = false;
        }
      });
    },
    getSelectVal() {
      this.$store.dispatch("form/handle", {
        url: "/battery/tree/historyField",
        data: { id: this.$route.query.data },
        method: "get",
        callback: resp => {
          resp.forEach(element => {
            if (element.protocolENG.startsWith("HV_")) {
              this.extVolts.push(element.protocolCHS);
              this.chartData.highVoltData.queryTypes = ["extVolts"];
            }
            if (element.protocolENG.startsWith("T")) {
              this.temps.push(element.protocolCHS);
              this.chartData.tempsData.queryTypes = ["temps"];
            }
            let pattern = /^C\d+$/;
            if (pattern.test(element.protocolENG)) {
              this.cells.push(element.protocolCHS);
              this.chartData.cellsData.queryTypes = ["cells"];
            }
            this.list.push({
              label: element.protocolCHS,
              value: element.protocolENG
            });
            this.options.push({
              label: element.protocolCHS,
              value: element.protocolENG
            });
          });
          this.form.selectVal = [];
          this.form.selectVal.push(this.options[0].label);
        }
      });
    },
    resetForm() {
      this.form.variableDate = "";
      this.form.selectVal = [];
      this.form.selectVal.push(this.options[0].label);
      this.pageNo = 1;
      this.pageSize = 10;
    },

    // 查询单个图表数据
    queryChartData(chart) {
      this.queryDataByTypes(chart.queryTypes, chart, chart.domId);
    },

    // 查询所有图表数据
    queryAllData() {
      Object.values(this.chartData).forEach(chart => {
        this.queryDataByTypes(chart.queryTypes, chart, chart.domId);
      });
    },

    queryDataByTypes(queryTypes, resultData, refName) {
      if (queryTypes.length === 0) {
        return;
      }

      resultData.seriesData = [];
      resultData.legendData = [];
      let tmpParamDate = "";
      if (this.form.variableDate.length > 0) {
        const date1 = new Date(this.form.variableDate[0]);
        const date2 = new Date(this.form.variableDate[1]);
        const diffTime = Math.abs(date2 - date1);
        if (diffTime > 3600 * 1000 * 24 * 3) {
          this.$message({
            message: "查询时间请不要超过3天！",
            type: "warning"
          });
          return;
        }
        tmpParamDate = this.form.variableDate.join(",");
      }
      this.$store.dispatch("form/handle", {
        url: "/battery/dcDevice/history2",
        data: {
          deviceId: this.$route.query.data,
          queryTime: tmpParamDate,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          params: queryTypes.join(",")
        },
        method: "get",
        callback: resp => {
          if (resp == null) {
            return;
          }
          resp.chart.forEach(_charts => {
            let seriesObj = {
              name: "",
              type: "line",
              smooth: true,
              data: []
            };
            seriesObj.name = _charts.variable;
            seriesObj.data = _charts.yAxis;
            resultData.seriesData.push(seriesObj);
            resultData.legendData.push(_charts.variable);
          });
          resultData.xAxisData = resp.chart[0].xAxis;
          this.$refs[refName][0].freshOption(
            resultData.seriesData,
            resultData.xAxisData,
            resultData.legendData
          );
        }
      });
    }
  },
  created() {
    this.getSelectVal();
  }
};
</script>

<style lang="less" scoped>
.history-charts {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.chart-container {
  min-height: 300px;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  position: relative;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.chart-title {
  font-weight: bold;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/historyDataNormal.vue